import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'previewEmails'

export default (data) => (asyncAction(
  name,
  ReportsService.previewEmails,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/previewEmails.js